import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"
import BannerInterior from '../components/BannerInterior'
import CarteraServicios from '../components/CarteraServicios'
import Instalaciones from '../components/InstalacionesSlider'
import EmpresasAkzent from '../components/EmpresasAkzent'
import Certificaciones from '../components/Certificaciones'

import bannerimg from '../images/banner-empresa.jpg'

const Empresa = ({ intl }) => (
  	<Layout>

		<SEO
			title={intl.formatMessage({ id: "header.empresa" })}
			description={intl.formatMessage({ id: "empresa.introtitulo" })}
		/>

		<BannerInterior titulo={intl.formatHTMLMessage({ id: "empresa.titulo" })} imgsrc={bannerimg}/>

		<div style={{ background: `#fff` }}>

			<div className="heading-banner-simple">
				<div className="cont">
					<div className="titulo">
						<h1><FormattedMessage id="empresa.introtitulo" /></h1>
					</div>
				</div>
			</div>

			<div className="container">
				<div className="row">
					<div className="col-md-9 col-lg-7">
						<p><strong><FormattedMessage id="empresa.introexp" /></strong></p>
						<p><FormattedMessage id="empresa.introtxt" /></p>
					</div>
				</div>
			</div>

		</div>

		<Instalaciones/>

		<EmpresasAkzent/>

		<Certificaciones/>

		<CarteraServicios/>

	</Layout>
)

export default injectIntl(Empresa)
